<template>
  <div>
    <div class="bg-blue bg-opacity-25 rounded-4 p-4">
      <h6 class="mb-1 text-sm">
        Apakah jawaban ini sudah cukup memuaskan?
      </h6>
      <span class="mr-6 cursor-pointer" :class="localLike===null || !localLike? 'text-primary':'text-premier-blue'" @click="like(id, true)"><font-awesome-icon icon="thumbs-up" class="mr-2" /> Sudah</span>
      <span class="cursor-pointer" :class="localLike===null || localLike? 'text-primary':'text-danger'" @click="like(id, false)"><font-awesome-icon icon="thumbs-down" class="mr-2" /> Belum</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      default: null
    },
    like: {
      type: Function,
      default: null
    },
    localLike: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      index: null
    }
  }
}
</script>
